export default "__VITE_ASSET__b5f83ac0__"